/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow
import type { Node } from 'react';

import React from 'react';
import { Button } from 'reactstrap';

type Props = {|
  onClick: Function,
  disabled?: boolean,
  disabledReason?: ?string,
|};

/*
 * "Try another document" (UI design §3.6) -- returns to the upload step for the same
 * model, targeting a new PDF. The same control, in the same place, whether reached from a
 * terminal-error progress screen (§2.4, this phase) or -- once wired -- from a rejected-
 * all/fresh model in the review surface itself; kept as one small presentational component
 * so both call sites share a single control rather than duplicating it.
 */
const TryAnotherDocumentButton = ({
  onClick,
  disabled = false,
  disabledReason = null,
}: Props): Node => (
  <>
    <Button color="primary" onClick={onClick} disabled={disabled}>
      Try another document
    </Button>
    {disabled && disabledReason && <p className="text-muted mt-2">{disabledReason}</p>}
  </>
);

export default TryAnotherDocumentButton;
